import { accessDeniedLocs } from './components/access-denied/access-denied.locs';
import { cpNotFoundLocs, spNotFoundLocs } from './components/not-found/not-found.locs';
import { cpSessionExpiredLocs, spSessionExpiredLocs } from './components/session-expired/session-expired.locs';

export const cpSharedPageLocs = {
	...accessDeniedLocs,
	...cpNotFoundLocs,
	...cpSessionExpiredLocs,
};
export const spSharedPageLocs = {
	...accessDeniedLocs,
	...spNotFoundLocs,
	...spSessionExpiredLocs,
};
